import type { ToggleButtonSize } from './toggle-button.ui';

/**
 * Figma `ToggleButton`(30:271). pressed=false / true 의 색. hover 는 누를 수 있을 때만.
 * 눌림(선택)은 primary 테두리 · 글자 + 옅은 primary 면(bg/primary-subtle) — 2026-10-07 사용자(DD-70)
 */
export const PRESSED_CLASS = {
  false:
    'border-border-control bg-bg-surface text-fg-muted enabled:hover:bg-bg-hover disabled:border-border-default disabled:bg-bg-disabled disabled:text-fg-disabled',
  true: 'border-border-primary bg-bg-primary-subtle text-fg-primary enabled:hover:bg-bg-primary-subtle-hover disabled:border-border-default disabled:bg-bg-disabled disabled:text-fg-disabled',
} as const;

/** 높이 · 좌우 여백 · 글자: xs 24 · sm 32 · md 40 */
export const SIZE_CLASS: Record<ToggleButtonSize, string> = {
  xs: 'h-(--size-control-2xs) px-2 typo-caption',
  sm: 'h-(--size-control-sm) px-4 typo-body-sm',
  md: 'h-(--size-control-md) px-4 typo-body-sm',
};
